<template>
  <van-row>
    <van-col span="4">
      <van-sidebar v-model="active" @change="onChange">
        <van-sidebar-item title="我的跟进" disabled />
        <van-sidebar-item title="客户列表" />
        <van-sidebar-item title="出诊安排" disabled/>
        <van-sidebar-item title="互动留言" disabled />
      </van-sidebar>
    </van-col>
    <van-col span="19" offset="1">
      <van-calendar
        title="出诊安排"
        type="multiple"
        v-model:show="show"
        :poppable="false"
        :default-date="defaultDateArr(doctorWork.DoctorWorkVo.workDateList)"
        :show-confirm="true"
        :formatter="formatter"
        :style="{ height: '500px' }"
        @confirm="onConfirm"/>
    </van-col>
  </van-row>
</template>
<script>
import { ref, reactive, onMounted } from "vue";
import { useRouter } from "vue-router";
import { postUserLog } from "../../api/userlog";
import { postDoctorWork,postGetDoctorWork } from "../../api/doctor";
export default {
  setup() {
    const text = ref("");
    const router = useRouter();
    const ulog = reactive({
      UserLog: {
        path: "",
      },
    });
    const doctorWork = reactive({
      DoctorWorkVo: {
        workDateList: "",
      },
    });
    const show = ref(false);
    const onConfirm = (dates) => {
      console.log(dates);
      var arr = new Array();
      for (var i = 0; i < dates.length; i++) {
        arr.push(`${dates[i].getFullYear()}/${dates[i].getMonth() + 1}/${dates[i].getDate()}`);
      }
      doctorWork.DoctorWorkVo.workDateList=arr;
      console.log(doctorWork.DoctorWorkVo.workDateList);
      postDoctorWork(doctorWork.DoctorWorkVo).then(()=>{
      
      })
    };

    const formatter = (day) => {
      const daylist=doctorWork.DoctorWorkVo.workDateList;
      const fullyear=day.date.getFullYear();
      const month = day.date.getMonth() + 1;
      const date = day.date.getDate();
      const curDate = `${fullyear}/${month}/${date}`;
      for (var i = 0; i < daylist.length; i++) {
          if(curDate===daylist[i]){
            day.bottomInfo = "出诊";
        }
      }
      return day;
    };
    const onChange = (index) => {
      if (index == 1) {
        router.push("/doctorIndex");
      } else if (index == 2) {
        router.push("/doctorWork");
      }
    };
    onMounted(() => {
      ulog.UserLog.path = router.currentRoute.value.fullPath;
      console.log("当前页面路径==" + ulog.UserLog.path);
      postUserLog(ulog.UserLog).then(() => {});
      postGetDoctorWork().then((res1) => {
        console.log(res1.data.data);
        doctorWork.DoctorWorkVo=res1.data.data;
      
      });
    });

    function defaultDateArr(datestr) {
      var arr = new Array();
        for (var i = 0; i < datestr.length; i++) {
          arr.push(new Date(datestr[i]));
        }
        return arr;
    }
    return {
      text,
      show,
      doctorWork,
      onChange,
      formatter,
      onConfirm,
      defaultDateArr,
    };
  },
};
</script>
<style scoped>
/deep/ .red-flag {
 background:#fa6861;
 color:#ffffff;
}
</style>
